import { render, staticRenderFns } from "./AddHelpAdmin.vue?vue&type=template&id=35e81f40&scoped=true"
import script from "./AddHelpAdmin.vue?vue&type=script&lang=js"
export * from "./AddHelpAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddHelpAdmin.vue?vue&type=style&index=0&id=35e81f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e81f40",
  null
  
)

export default component.exports